import React, { useState } from "react";
import styles from "./FAQs.module.scss";
import { Col, Container, Input, Row } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import OrderTransactionsComp from "../../../../components/AdminPortalComponents/BusinessManagement/OrderTransactions/OrderTransactions.comp";
import ComponentBackButton from "../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import InsightsIcon from "../../../../assets/icons/Admin/insights.svg"
import { useNavigate } from "react-router-dom";
import RefundTransactionsComp from "../../../../components/AdminPortalComponents/Refund&DisputeManagement/RefundTransactions/RefundTransaction.comp";
import DetailsCard from "../../../../components/common/AdminCommonComponents/DetailsCard/DetailsCard";
import DynamicButton from "../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import FAQsComp from "../../../../components/AdminPortalComponents/Support&Communication/FAQs/FAQs.comp";
import GrayHeading from "../../../../components/common/AdminCommonComponents/GrayHeading/GrayHeading";
import DynamicDropdown from "../../../../components/common/AdminCommonComponents/DynamicDropdown/DynamicDropdown";

const orderFulfillmentData = [
    { title: "total categories", value: 0 },
    { title: "total faqs", value: 0 },
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));

const refundInfo = [
    {
        key: "Transaction ID:",
        value: "R-100"
    },
    {
        key: "Refund ID:",
        value: "R-100"
    },
    {
        key: "Order ID:",
        value: "R-100"
    },
    {
        key: "Customer Name:",
        value: "Full Name",
        color: true
    },
    {
        key: "Seller Name:",
        value: "Full Name",
        color: true
    },
    {
        key: "Refund Amount:",
        value: "$200",
        valColor: true
    },
    {
        key: "Request Date:",
        value: "Nov, 17 2090"
    },
    {
        key: "Status:",
        value: "Issued"
    },
]
const orderDetails = [
    {
        key: "Products name: ",
        value: "Product"
    },
    {
        key: "Purchase Date:",
        value: "10/10/2020"
    },


]





const FAQs = () => {
    const [detailView, setDetailView] = useState(false)
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Overview</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>
            {!detailView &&
                <>
                    <Container fluid className={styles.filterTableWrapper}>
                        <div className="p-3 d-flex align-items-center justify-content-between">
                            <div className={`fw-semibold fs-4 ${styles.text} `}>Freqeuntly Asked Questions</div>
                            <DynamicButton onClick={() => setDetailView(true)} theme="blue">Add new FAQ</DynamicButton>
                        </div>

                        <FAQsComp setDetails={() => setDetailView(true)} />
                    </Container>
                </>}
            {detailView &&
                <Container fluid className={styles.orderWrapper}>
                    <ComponentBackButton onClick={() => setDetailView(false)} />
                    <div className="d-flex justify-content-center items-center">
                        <GrayHeading>Add New FAQ</GrayHeading>
                    </div>

                    <div className={styles.dropdownContainer}>
                        <div className={styles.dropdown}>
                            <div>Category</div>
                            <DynamicDropdown placeholder="Dropdown" />
                        </div>
                        <div className={styles.dropdown}>
                            <div>Sub-Category</div>
                            <DynamicDropdown placeholder="Dropdown" />
                        </div>
                    </div>

                    <div className={styles.dropdownContainer}>
                        <div className={styles.dropdown}>
                            <div>Ranking</div>
                            <DynamicDropdown placeholder="Dropdown" />
                        </div>
                        <div className={styles.dropdown}>
                            <div>Status</div>
                            <DynamicDropdown placeholder="Offline/Online" />
                        </div>
                    </div>

                    <div className={styles.dropdownContainer}>
                        <div className={styles.dropdown}>
                            <div>Question</div>
                            <Input type="textarea" aria-multiline />
                        </div>
                        <div className={styles.dropdown}>
                            <div>Answer</div>
                            <Input type="textarea" aria-multiline />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center items-center mt-4">
                        <DynamicButton theme="blue">Add FAQ</DynamicButton>
                    </div>
                </Container>
            }
        </div>
    );
};

export default FAQs;